import { AdBiddingProvider, IAdBiddingProviderConfig } from '../../..'
import { logger } from '../../../../../../utils/common/logger'
import { DOMUtils } from '../../../../../../utils/dom'
import { AdBiddingBase } from '../base'

class IndexExchange extends AdBiddingBase {
    public requestAds: undefined
    public requestAdsPromise: undefined
    protected URLPath: string
    protected waitForBidder = false

    constructor() {
        super()
        this.URLPath = '//js-sec.indexww.com/ht/p/'
    }

    public initializeBidding(confs: IAdBiddingProviderConfig[]): void {
        const conf = confs.find((_) => _.client === AdBiddingProvider.INDEX_EXCHANGE)
        if (conf) {
            DOMUtils.loadScript(`${this.URLPath}${conf.account}.js`)
            logger(`debug`, `Initialize IndexExchange bidder: ${this.URLPath}`)
        }
    }
}

export default IndexExchange
